---
title: 'Step 4: Configure Service Integration'
install_track_title: 'Log Insights: Setup (Aiven)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import imgAddSyslogIntegration from './add-syslog-integration.png'
import imgManageIntegrations from './manage-integrations.png'
import imgUseSyslogIntegration from './use-syslog-integration.png'
import imgSyslogIntegrationActive from './syslog-integration-active.png'
import imgLogInsightsScreenshot from '../log_insights_screenshot.png'

export const ImgAddSyslogIntegration = () => <div style={{display: 'flex', justifyContent: 'center'}}><img alt="Add new syslog service integration in Aiven Console" src={imgAddSyslogIntegration} style={{maxWidth: 500}} /></div>

export const ImgManageIntegrations = () => <img alt="Manage Integrations item in database details page" src={imgManageIntegrations} />

export const ImgUseSyslogIntegration = () => <img alt="Select the Rsyslog integration in the integration list" src={imgUseSyslogIntegration} />

export const ImgSyslogIntegrationActive = () => <img alt="Select the Rsyslog integration" src={imgSyslogIntegrationActive} />

export const ImgLogInsightsScreenshot = () => <img src={imgLogInsightsScreenshot} alt='Screenshot of pganalyze Log Insights feature' />

The last step is setting up the Aiven Service Integration. Go to the
Service Integration page in your Aiven console, select Syslog from the
list of options, and click "Add new endpoint".

### Setup using VPC

Fill in the Endpoint form with the internal IP of your collector instance and
the port you selected in the previous step. Disable TLS (since you're sending
logs over the peered VPC connection, the traffic is already private). Leave the
format as rfc5424, and the other fields blank:

<ImgAddSyslogIntegration />

### Setup using TLS

Fill in the Endpoint form with the hostname or IP of your collector instance and
the port that you specified during the collector syslog server setup. Please
make sure that the collector is accessible from the Aiven instance.
Enable TLS and leave the format as rfc5424. If you are using the certificate
issued by an internal CA or a self-signed certificate on the collector syslog
server side, make sure to provide it as a "PEM encoded CA certificate".
Leave a "PEM encoded client certificate" and a "PEM encoded client key" blank.

Once this is done, return to the service details page for your database, and
click Manage Integrations:

<ImgManageIntegrations />

Scroll down to the bottom, find the Rsyslog tile, and click "Use Integration":

<ImgUseSyslogIntegration />

Select the endpoint you just created from the dropdown and click "Enable". Then
dismiss the integrations screen.

After a few minutes, the Service Integrations item should refresh automatically and
show your integration as active:

<ImgSyslogIntegrationActive />

<PublicOnly>
  <p>
    Once the syslog connection is active, you will start seeing log events on the
    Log Insights page in pganalyze.
  </p>
  <p>
    <ImgLogInsightsScreenshot />
  </p>
  <p>
    We recommend setting up <a href="/docs/explain/setup/log_explain">Log-based EXPLAIN</a> as
    a follow-up step, to automatically EXPLAIN slow queries in Postgres.
    As an alternative to Log-based EXPLAIN, you can integrate the auto_explain module with
    <a href="https://github.com/aiven/aiven-extras?tab=readme-ov-file#examples">some changes</a> to
    your application.
  </p>
</PublicOnly>
